// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"51":"d59dbe7f","237":"06b7c120","416":"3698fcb4","440":"bbf046e9","638":"5e490894","753":"f5dcc08d","776":"3bc42143","805":"d68cea30","852":"a9d923f7"}[chunkId] + ".chunk.js";
};